import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Adds a subtle edge-fade to horizontally scrollable tab strips so users know
// more tabs exist off-screen. Sets data-sh="left|right|both" on each scrollable
// `[role="tablist"]` / `.scroll-hint` element based on its scroll position; the
// matching mask-image fade lives in index.css. Fade disappears at the ends.
const SEL = '[role="tablist"], .scroll-hint';

export default function ScrollHint() {
  const { pathname } = useLocation();

  useEffect(() => {
    const update = (el) => {
      const more = el.scrollWidth - el.clientWidth;
      if (more <= 2) { el.removeAttribute('data-sh'); return; }
      const left = el.scrollLeft > 2;
      const right = el.scrollLeft < more - 2;
      const state = left && right ? 'both' : left ? 'left' : right ? 'right' : '';
      if (state) el.dataset.sh = state; else el.removeAttribute('data-sh');
    };
    const updateAll = () => document.querySelectorAll(SEL).forEach(update);
    const onScroll = (e) => { const t = e.target; if (t && t.matches && t.matches(SEL)) update(t); };

    document.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', updateAll);
    // Re-scan periodically to catch lazily-rendered tab strips / tab count changes.
    const iv = setInterval(updateAll, 800);
    const t1 = setTimeout(updateAll, 150);
    const t2 = setTimeout(updateAll, 700);
    updateAll();
    return () => {
      document.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', updateAll);
      clearInterval(iv); clearTimeout(t1); clearTimeout(t2);
    };
  }, [pathname]);

  return null;
}
